/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ShareCreateResponseSchema {
  share_id: string;
  token: string;
  url: string;
  expires_at: string;
  expiration_days: number;
}
